export default new Map<string, { var: string; cssVar?: string; assignDefault?: string[] }>([
  [
    'labelColor',
    {
      var: 'components.label.states.default.color',
      cssVar: 'label-color',
    },
  ],
  [
    'labelFont',
    {
      var: 'components.label.size.default.typography',
      cssVar: 'label-font',
    },
  ],
]);
